import { initializeApp } from 'firebase/app';
import { initializeAuth, getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY || 'AIzaSyACA_VS-iQ4wEbCJYdL2URUEJu19Xiwf9c',
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN || 'tufs-60fe7.firebaseapp.com',
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID || 'tufs-60fe7',
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET || 'tufs-60fe7.appspot.com',
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '355937711753',
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID || '1:355937711753:web:425b1ab346d220824d3858',
  measurementId: process.env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID || 'G-CXHE60F3EE',
};

const app = initializeApp(firebaseConfig);
let auth: Auth;
if (Platform.OS === 'web') auth = getAuth(app);
else {
  const { getReactNativePersistence } = require('firebase/auth');
  auth = initializeAuth(app, { persistence: getReactNativePersistence(AsyncStorage) });
}
const db: Firestore = getFirestore(app);
const analytics: any = Platform.OS === 'web' ? getAnalytics(app) : null;

export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (analytics && Platform.OS === 'web') logEvent(analytics, eventName, parameters);
};

export { auth, db, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail };
